const fonts = {
	BOGLE_MEDIUM: 'Bogle-Medium',
	BOGLE_REGULAR: 'Bogle-Regular',
	BOGLE_LIGHT: 'Bogle-Light',
	BOGLE_BOLD: 'Bogle-Bold',
	BOGLE: 'Bogle'
};

export default fonts;
